module.exports = __webpack_public_path__ + "static/4-5ddf9204ca0b7668a7c303c8347eba08.png";